import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { AnyEntity } from "@mapmycustomers/shared/types/entity";

import RecordsCadenceEffectivenessCardData from "@app/scene/dashboard/store/cards/recordsCadenceEffectiveness/RecordsCadenceEffectivenessCardData";
import { DrillDownListFetcherPayload } from "@app/scene/dashboard/types/DrillDownListFetcher";
import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import RecordsCadenceEffectivenessBand from "@app/types/dashboard/cards/recordsCadenceEffectiveness/RecordsCadenceEffectivenessBand";
import RecordsCadenceEffectivenessCardConfiguration from "@app/types/dashboard/cards/recordsCadenceEffectiveness/RecordsCadenceEffectivenessCardConfiguration";
import DashboardCard from "@app/types/dashboard/DashboardCard";
import Scope from "@app/types/dashboard/Scope";

export const fetchRecordsCadenceEffectivenessCardData = createAction(
  "@dashboard/fetchRecordsCadenceEffectivenessCardData"
)<{
  callback: (data: RecordsCadenceEffectivenessCardData) => void;
  cardId: DashboardCard["id"];
  configuration: RecordsCadenceEffectivenessCardConfiguration;
  failureCallback?: () => void;
  scope?: Scope;
}>();

export const showRecordsCadenceEffectivenessDrillDown = createAsyncAction(
  "@dashboard/showRecordsCadenceEffectivenessCardDrillDownModal/request",
  "@dashboard/showRecordsCadenceEffectivenessCardDrillDownModal/success",
  "@dashboard/showRecordsCadenceEffectivenessCardDrillDownModal/failure"
)<
  {
    band: RecordsCadenceEffectivenessBand;
    configuration: RecordsCadenceEffectivenessCardConfiguration;
    scope: Scope;
  },
  { viewState: DrillDownViewState },
  void
>();

export const hideRecordsCadenceEffectivenessDrillDown = createAction(
  "@dashboard/hideRecordsCadenceEffectivenessCardDrillDownModal"
)<void>();

// Switches the drilled-into band without reopening: the grid refetches with the new
// band's `cadenceDaysOut` range (see the drilldown saga).
export const setRecordsCadenceEffectivenessDrillDownBand = createAction(
  "@dashboard/setRecordsCadenceEffectivenessDrillDownBand"
)<RecordsCadenceEffectivenessBand>();

export const fetchRecordsCadenceEffectivenessCardDrillDownData = createAsyncAction(
  "@dashboard/fetchRecordsCadenceEffectivenessCardDrillDownData/request",
  "@dashboard/fetchRecordsCadenceEffectivenessCardDrillDownData/success",
  "@dashboard/fetchRecordsCadenceEffectivenessCardDrillDownData/failure"
)<
  DrillDownListFetcherPayload<AnyEntity>,
  {
    totalFilteredRecords: number;
    totalRecords: number;
  },
  void
>();

export const applyRecordsCadenceEffectivenessDrillDownListViewSettings = createAction(
  "@dashboard/applyRecordsCadenceEffectivenessDrillDownListViewSettings"
)<Partial<DrillDownViewState>>();

export const exportRecordsCadenceEffectivenessCardDrillDownData = createAction(
  "@dashboard/exportRecordsCadenceEffectivenessCardData"
)<{
  configuration: RecordsCadenceEffectivenessCardConfiguration;
  scope: Scope;
}>();

export type RecordsCadenceEffectivenessCardActions = ActionType<
  | typeof applyRecordsCadenceEffectivenessDrillDownListViewSettings
  | typeof exportRecordsCadenceEffectivenessCardDrillDownData
  | typeof fetchRecordsCadenceEffectivenessCardData
  | typeof fetchRecordsCadenceEffectivenessCardDrillDownData
  | typeof hideRecordsCadenceEffectivenessDrillDown
  | typeof setRecordsCadenceEffectivenessDrillDownBand
  | typeof showRecordsCadenceEffectivenessDrillDown
>;
